// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"coachingProcessContent-module--imageWrapper--3Mbsm","bottomImageContent":"coachingProcessContent-module--bottomImageContent--3n4aC"};